<template>
  <div class="layanan-item no-hover card">
    <div class="card-body">
      <div class="d-flex">
        <div class="layanan-icon mr-3 text-center">
          <img :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+dataPermohonan.paket_layanan.layanan.icon">
        </div>
        <div>
          <h6>{{ dataPermohonan.paket_layanan.layanan.nama_layanan }}</h6>
          <p>{{ dataPermohonan.paket_layanan.paket.nama_paket }}</p>
        </div>
      </div>
      <hr>
      <table class="table table-sm">
        <tr>
          <td>Nama Pemohon</td>
          <td>
            <b>{{ dataPermohonan.penduduk.nama_lengkap }}</b>
          </td>
        </tr>
        <tr>
          <td>NIK</td>
          <td><b>{{ dataPermohonan.penduduk.nik }}</b></td>
        </tr>
        <tr>
          <td>Desa</td>
          <td><b>{{ dataPermohonan.penduduk.desa.nama_desa }}, {{ dataPermohonan.penduduk.desa.nama_kecamatan }}</b></td>
        </tr>
        <tr>
          <td>Email</td>
          <td v-if="dataPermohonan.id_operator_pembantu">
            <b>{{ dataPermohonan.user_pembantu.email }}</b> <i>{{ dataPermohonan.user_pembantu.penduduk.nama_lengkap }} (Operator Desa)</i>
          </td>
          <td v-else>
            <b>{{ (dataPermohonan.penduduk.user) ? dataPermohonan.penduduk.user.email : '-' }}</b>
          </td>
        </tr>
        <tr>
          <td>Nomor HP</td>
          <td v-if="dataPermohonan.id_operator_pembantu">
            <b>{{ dataPermohonan.user_pembantu.no_hp }}</b> <i>{{ dataPermohonan.user_pembantu.penduduk.nama_lengkap }} (Operator Desa)</i>
          </td>
          <td v-else>
            <b>{{ (dataPermohonan.penduduk.user) ? dataPermohonan.penduduk.user.no_hp : '-' }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2" />
        </tr>
        <!-- <tr>
                    <td>Jenis Permohonan</td>
                    <td><b>{{dataPermohonan.paket_layanan.layanan.nama_layanan}}</b></td>
                </tr> -->
        <tr>
          <td>Nomor</td>
          <td>
            <span
              class="font-weight-bold text-primary"
              v-if="dataPermohonan.nomor_surat_pengantar && dataPermohonan.nomor_surat_pengantar != 'null'"
            >
              {{ dataPermohonan.nomor_surat_pengantar }}
            </span>
            <span
              class="font-weight-bold text-primary"
              v-else
            >
              Nomor Surat Belum Dimasukkan
            </span>
          </td>
        </tr>
        <tr>
          <td>Tanggal Buat Permohonan</td>
          <td>
            {{ new Date(tanggalBuatPermohonan).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) }}
            {{ tanggalBuatPermohonan.substr(11, 8) }}
          </td>
        </tr>
        <tr v-if="dataPermohonan.status >= 15">
          <td>Tanggal Dokumen Selesai</td>
          <td>
            {{ new Date(dataPermohonan.timestamp_status_15).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) }}
            {{ dataPermohonan.timestamp_status_15.substr(11, 8) }}
            ({{ waktuProsesPermohonan }})
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <span
              v-if="dataPermohonan.status === 0"
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Belum Diajukan</span>
            <span
              v-if="dataPermohonan.status === 1"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Diajukan ke Desa</span>
            <span
              v-if="dataPermohonan.status === 2"
              class="badge badge-warning"
            ><i class="fa fa-check-circle mr-2" />Diproses di Desa</span>
            <span
              v-if="dataPermohonan.status === 3"
              class="badge badge-warning"
            ><i class="fa fa-info-circle mr-2" />Revisi tingkat Desa</span>
            <span
              v-if="dataPermohonan.status === 4"
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Ditolak Desa</span>
            <span
              v-if="dataPermohonan.status === 5"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Diajukan ke Kecamatan</span>
            <span
              v-if="dataPermohonan.status === 6"
              class="badge badge-warning"
            ><i class="fa fa-check-circle mr-2" />Diproses di Kecamatan</span>
            <span
              v-if="dataPermohonan.status === 7"
              class="badge badge-warning"
            ><i class="fa fa-info-circle mr-2" />Revisi tingkat Kecamatan</span>
            <span
              v-if="dataPermohonan.status === 8"
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Ditolak Kecamatan</span>
            <span
              v-if="dataPermohonan.status === 9"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Diajukan ke Dukcapil</span>
            <span
              v-if="dataPermohonan.status === 10"
              class="badge badge-warning"
            ><i class="fa fa-check-circle mr-2" />Diproses di Dukcapil</span>
            <span
              v-if="dataPermohonan.status === 11"
              class="badge badge-warning"
            ><i class="fa fa-info-circle mr-2" />Revisi tingkat Dukcapil</span>
            <span
              v-if="dataPermohonan.status === 12"
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Ditolak Dukcapil</span>
            <span
              v-if="dataPermohonan.status === 13"
              class="badge badge-danger"
            ><i class="fa fa-info-circle mr-2" />Dibatalkan</span>
            <span
              v-if="dataPermohonan.status === 14"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Valid Tingkat Dukcapil</span>
            <span
              v-if="dataPermohonan.status === 15"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Berkas Siap Diambil</span>
            <span
              v-if="dataPermohonan.status === 16"
              class="badge badge-success"
            ><i class="fa fa-check-circle mr-2" />Selesai</span>

            <span
              v-if="dataPermohonan.status === 0"
              class="badge badge-primary"
            >Tahap {{ dataPermohonan.tahap }}</span>
          </td>
        </tr>
        <tr v-if="filePermohonan">
          <!-- jika sudah upload, pakai yang diupload, supaya tidak bentrok -->
          <td v-if="filePermohonan.findIndex(e => e.dokumen.kode_dokumen === 'F1.02') === -1">
            Formulir Pendaftaran
          </td>
          <td v-if="filePermohonan.findIndex(e => e.dokumen.kode_dokumen === 'F1.02') === -1">
            <button
              id="btnCetakFormulirPendaftaran"
              @click="downloadFormulirPendaftaran"
              class="btn btn-primary btn-sm"
              title="Download Formulir Pendaftaran"
            >
              <i class="fa fa-download mr-2" />
              Download
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data() {
    return {

    }
  },
  computed: {
    dataPermohonan() {
      return this.$store.getters.getDataPermohonan
    },
    filePermohonan() {
      return this.$store.getters.getFilePermohonan
    },
    tanggalBuatPermohonan() {
      let tanggal = ''
      if (this.dataPermohonan.paket_layanan.is_valid_desa === 1) {
        tanggal = this.dataPermohonan.timestamp_status_1
      } else if (this.dataPermohonan.paket_layanan.is_valid_kecamatan === 1) {
        tanggal = this.dataPermohonan.timestamp_status_5
      } else if (this.dataPermohonan.paket_layanan.is_valid_dukcapil === 1) {
        tanggal = this.dataPermohonan.timestamp_status_9
      }
      return tanggal
    },
    waktuProsesPermohonan() {
      const waktuSelesai = new Date(this.dataPermohonan.timestamp_status_15)
      const waktuAjukan = new Date(this.tanggalBuatPermohonan)

      const seconds = Math.floor((waktuSelesai - waktuAjukan) / 1000)

      let interval = seconds / 2592000
      if (interval > 1) {
        return Math.floor(interval) + ' bulan'
      }
      interval = seconds / 86400
      if (interval > 1) {
        return Math.floor(interval) + ' hari'
      }
      interval = seconds / 3600
      if (interval > 1) {
        return Math.floor(interval) + ' jam'
      }
      interval = seconds / 60
      if (interval > 1) {
        return Math.floor(interval) + ' menit'
      }
      return Math.floor(seconds) + ' detik'
    }
  },
  methods: {
    downloadFormulirPendaftaran() {
      let button = document.querySelector('#btnCetakFormulirPendaftaran')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Mencetak...'

      this.$store.dispatch('cetakFormPendaftaranKependudukanByPermohonan', this.dataPermohonan.id_data_permohonan).then(res => {
        let blob = new Blob([res.data], { type: 'application/pdf' }),
          url = window.URL.createObjectURL(blob)

        window.open(url)
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
      })
        .catch(err => {
          console.log(err)
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml
          switch (err.response.status) {
            case 500:
              this.$router.push({ path: '/500' })
              break;

            case 400:
              swal({
                title: "Gagal",
                text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
              break;

            default:
              swal({
                title: "Gagal",
                text: err.response.data.message,
                icon: "error",
                buttons: "Ok"
              })
              break;
          }
        })
    }
  }
}
</script>